import {Component, Input, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material';
import {UserPermisService} from '../user-permis/user-permis.service';
import {UsersService} from '../users.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {HttpParams} from '@angular/common/http';
import {NgxPermissionsService} from 'ngx-permissions';

@Component({
	selector: 'kt-user-parking',
	templateUrl: './user-parking.component.html',
	styleUrls: ['./user-parking.component.scss']
})
export class UserParkingComponent implements OnInit {
	@Input() public id;
	@Input() public permission;
	subCategoryList = new MatTableDataSource<any>();

	perm;
	eventList;
	selectedRow;
	parkingLists;
	visible: boolean = false;
	// displayedColumns = ['eventname', 'parkingName', 'darab', 'functions'];
	displayedColumns: string[];
	constructor(private ngxPermissionService: NgxPermissionsService,private service1: UserPermisService, private service: UsersService, public activeModal: NgbActiveModal, private toastr: ToastrService) {
	}

	ngOnInit() {
		this.getData();
		this.Visible();
		this.getEvents();
		this.getAvailableParkingSlots();
		this.getDisplayedColumns();
	}

	Visible() {
		// this.visible = this.ngxPermissionService.getPermissions().hasOwnProperty(this.permission);
		this.perm = this.ngxPermissionService.getPermissions().hasOwnProperty(this.permission);
		if(this.perm == this.permission){
			this.visible = false
		}else{
			this.visible = true
		}
		if(this.permission=='ALSUPERVISOR'){
			this.visible = false;
		}
		// const role = localStorage.getItem('role');
		// if (role == this.permission) {
		// 	this.visible = false;
		// } else {
		// 	this.visible = true;
		// }
	}


	getDisplayedColumns() {
		if (this.permission == 'ADMIN' || this.permission =='ALSUPERVISOR') {
			this.displayedColumns = [
				'eventname',
				'parkingName',
				'darab'
			];
		} else {
			if (!this.visible) {
				this.displayedColumns = [
					'eventname',
					'parkingName',
					'darab'
				];
			} else {
				this.displayedColumns = [
					'eventname',
					'parkingName',
					'darab',
					'functions'
				];
			}
		}
	}

	getAvailableParkingSlots() {
		this.service.getAvailableParkingSlots(this.id).subscribe((res) => {
			this.parkingLists = res.parkingSlots;
		});
	}

	getEvents() {
		let params = new HttpParams();
		params = params.append('id', this.id);
		this.service1.getUserEvents(params).subscribe((res) => {

			this.eventList = res;
		});
	}

	getData() {
		this.service.getParkingLimitToSupervisor(this.id).subscribe((res) => {
			this.subCategoryList.data = res;
		});
	}

	removeSubCateg(item) {

		const index = this.subCategoryList.data.indexOf(item.id);
		this.subCategoryList.data.splice(item, 1);
		this.subCategoryList._updateChangeSubscription();
	}

	addSubcateg() {

		if (this.subCategoryList.data) {
			this.subCategoryList.data.push({
				eventId: '',
				parkingSlotId: '',
				limit: ''
			});
		} else {
			this.subCategoryList.data = [];
		}
		this.subCategoryList.data = this.subCategoryList.data;
	}

	save() {
		const data = {
			userId: this.id,
			limits:
			this.subCategoryList.data

		};
		this.service.modifyParkingLimitToSupervisor(data).subscribe((res) => {
				this.toastr.success('Sikeresen mentve', '');
				this.activeModal.close(true);
			}, (error) => {
				this.toastr.error(error.error.message, '', {timeOut: 5000});
			}
		);
	}

}
